import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Box, TextField, Typography } from "@material-ui/core";
import renderHTML from "react-render-html";

const styles = (theme) => ({
  paper: {
    width: "100%",
    border: "1px solid #DFEFFE",
    boxShadow: "0 0 0 1px rgba(24, 144, 255, 0.2)",
  },
  customizedText: {
    color: "#cccccc",
  },
});

const AutoSuggest = (props) => {
  const {
    id = "controllable-autocomplete",
    field,
    handleChange,
    // label,
    options = [],
    option = { title: "", value: "" },
    disabled = false,
    changeOptionBaseOnValue = () => {},
    isCustomized = false,
  } = props;

  const [value, setValue] = useState(option ?? { title: "", value: "" });
  const [inputValue, setInputValue] = useState(option?.title ?? "");

  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
        handleChange(field, newValue?.value || "");
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
        changeOptionBaseOnValue(newInputValue, field);
      }}
      id={id}
      options={options}
      getOptionLabel={(option) => (option ? option.title : "")}
      renderOption={(option) => (
        <Box style={{ width: "100%" }}>
          <Typography variant="body1">{option.title}</Typography>
          {isCustomized && (
            <Box
              className={styles.customizedText}
              style={{ fontSize: "13px" }}
            >
              <small className={styles.customizedText}>
                {renderHTML(
                  `${option?.address?.address_line_1}${
                    option?.address?.address_line_2
                      ? option?.address?.address_line_2
                      : ""
                  }, ${option?.city}, ${option?.state}, ${
                    option?.pincode
                  }`
                )}
              </small>
            </Box>
          )}
        </Box>
      )}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label={""} variant="outlined" />
      )}
      classes={{
        paper: props.classes.paper,
      }}
    />
  );
};

//export default AutoSuggest;

export default withStyles(styles)(AutoSuggest);
